import React, { FC, ReactNode, MouseEvent } from 'react'

import LinkWithLocale from './LinkWithLocale'
import OuterLink from './OuterLink'

import { isOutLink } from '../utils/misc'

interface Props {
  className?: string
  url: string
  children: ReactNode
  onClick?: (e: MouseEvent) => void
}

const LinkWrapper: FC<Props> = ({ className, url, children, onClick }) => {
  if (isOutLink(url)) {
    return (
      <OuterLink className={className} href={url} onClick={onClick}>
        {children}
      </OuterLink>
    )
  }

  return (
    <LinkWithLocale className={className} to={url} onClick={onClick}>
      {children}
    </LinkWithLocale>
  )
}

export default LinkWrapper
